<template>
	<h1>Hello world</h1>
</template>

<script>
export default {};
</script>
